import { useFlags } from "launchdarkly-react-client-sdk";
import { FLAGS, type FlagValues } from "./flags";

export type FeatureFlagsState = FlagValues & {
  hasEnterpriseAppEnabledFlag: boolean;
};

export function useFeatureFlags(): FeatureFlagsState {
  const flags = useFlags<
    Partial<FlagValues> & { enterpriseAssetsV2?: boolean }
  >();

  return {
    ...FLAGS,
    ...flags,
    // The LaunchDarkly React SDK camel-cases hyphenated flag keys by default.
    "enterprise-assets-v2":
      flags.enterpriseAssetsV2 ??
      flags["enterprise-assets-v2"] ??
      FLAGS["enterprise-assets-v2"],
    hasEnterpriseAppEnabledFlag: Object.hasOwn(flags, "enterpriseAppEnabled"),
  };
}
